import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/simple_tree.svg'
import _imports_1 from '@/assets/icons/group_gray_150.png'


const _withScopeId = n => (_pushScopeId("data-v-4fe8e14d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "plan-details"
}
const _hoisted_2 = { class: "list-unstyled" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Tree"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "People"
}, null, -1))

import { getPlanContentLimitText, SubscriptionPlan } from '@/gp/GroupAdminModel'
import SubscriptionPrice from './SubscriptionPrice.vue'
import { CheckIcon, ImageIcon } from '@zhuowenli/vue-feather-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'SubscriptionPlanCard',
  props: {
    plan: {},
    showDetails: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



function planType(planId: string) {
  return planId.split('.')[0] // "mem.1" => "mem"
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["subscription-plan-card", { ['show-details']: _ctx.showDetails }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["plan-header", planType(_ctx.plan.id!)])
    }, _toDisplayString(_ctx.plan.displayName), 3),
    _createVNode(SubscriptionPrice, { plan: _ctx.plan }, null, 8, ["plan"]),
    (_ctx.showDetails)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("ul", _hoisted_2, [
            _createElementVNode("li", null, [
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(_ctx.plan.treeLimit) + " trees ", 1)
            ]),
            _createElementVNode("li", null, [
              _createVNode(_unref(ImageIcon)),
              _createTextVNode(" " + _toDisplayString(_unref(getPlanContentLimitText)(_ctx.plan.contentLimit)) + " photos ", 1)
            ]),
            _createElementVNode("li", null, [
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(_ctx.plan.shareLimit) + " people ", 1)
            ])
          ]),
          _createVNode(_component_router_link, { to: "/plans" }, {
            default: _withCtx(() => [
              _createTextVNode("Full details")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})